// Libs
import React from 'react';

// Components
import CartProductQtyButtons from '../../../CartProductQtyButtons/CartProductQtyButtons';
import KitProductQty from '../../../../Kits/KitProductQty/KitProductQty';

const CartCardKitOrCartQtyButtons = ({
  isTabletMode,
  placedOrder,
  kit,
  isUnavailableForOrder,
  readOnly,
  nums,
  product,
  isMobileMode,
  KitQtyComponent,
  isOverLimitProduct,
  addOneProduct,
  removeOneProduct,
  setCount,
  count,
  disabledCountBtn,
  addressesCount,
  classes,
}) => {
  if (!isTabletMode || placedOrder?.id) {
    return null;
  }

  if (kit) {
    if (isUnavailableForOrder) {
      return null;
    }
    return readOnly ? (
      <KitProductQty nums={nums} className={classes.qtyButtons} />
    ) : (
      <KitQtyComponent
        product={product}
        isMobileMode={isMobileMode}
        nums={nums}
        detailsMode={false}
        listView
        className={classes.qtyButtons}
      />
    );
  }

  return (
    <CartProductQtyButtons
      isOverLimit={isOverLimitProduct}
      product={product}
      onAdd={addOneProduct(product)}
      onRemove={removeOneProduct(product)}
      onSetCount={setCount}
      count={count}
      isMobileMode={isMobileMode}
      detailsMode={false}
      className={classes.qtyButtons}
      disabledCountBtn={disabledCountBtn}
      shippingAddresses={addressesCount}
    />
  );
};

const CartCardPlacedOrderInfo = ({
  isMobileMode,
  pendingApproval,
  orderedQty,
  totalOrderedQty,
  classes,
  cx,
}) =>
  isMobileMode && (
    <div>
      <div className={classes.qtyLabels}>{`Order Qty${
        pendingApproval ? '(Requested)' : ''
      }: ${orderedQty}`}</div>
      <div
        className={cx(
          classes.qtyLabels,
          classes.totalItems,
        )}>{`Total Ordered: ${totalOrderedQty}`}</div>
      {pendingApproval && (
        <div className={classes.approvalInfo}>Pending Approval</div>
      )}
    </div>
  );

const CartCardTotalsInfo = ({
  isMobileMode,
  reviewOrderPage,
  kit,
  isUnavailableForOrder,
  availableQuantity,
  unavailableLabel,
  totalItemsHeader,
  totalItemsQty,
  addressesCount,
  isDesktopMode,
  distributionUnitsQty,
  classes,
  cx,
}) => (
  <div>
    {isMobileMode &&
      (reviewOrderPage || kit) &&
      (!isUnavailableForOrder ? (
        <div
          className={classes.qtyLabels}>{`In stock: ${availableQuantity}`}</div>
      ) : (
        <span className={classes.accentBold}>{unavailableLabel}</span>
      ))}
    {!kit && (
      <div
        className={cx(classes.qtyLabels, classes.totalItems)}
        data-testid="product-card-total-items">{`${totalItemsHeader}: ${totalItemsQty}`}</div>
    )}
    {reviewOrderPage && addressesCount > 1 && (
      <div className={classes.qtyLabels}>{`${
        isDesktopMode ? 'Total Units In Distribution' : 'Units In Distro'
      }: ${distributionUnitsQty}`}</div>
    )}
  </div>
);

const CartCardFooter = (props) => {
  const { placedOrder, classes } = props;

  return (
    <div className={classes.totalItemsContainer}>
      <CartCardKitOrCartQtyButtons {...props} />
      {placedOrder?.id ? (
        <CartCardPlacedOrderInfo {...props} />
      ) : (
        <CartCardTotalsInfo {...props} />
      )}
    </div>
  );
};

export default CartCardFooter;
